export default "__VITE_ASSET__7EpzmvZg__"